// extracted by mini-css-extract-plugin
export default {"loader":"loader__7Ma5S","msg-range":"msg-range__UE2vM","msg-title":"msg-title__VJmz+","msg-subtitle":"msg-subtitle__PjCnx"};